export default __webpack_public_path__ + "static/media/esperando.21448577.png";